/*
  Product page media loading + add-to-cart feedback.

  Cover loading: the frame keeps a shimmer placeholder until the cover image reports it has
  decoded, then gets `is-loaded` so CSS can fade the image in. Images restored from cache
  are already `complete` on script run, so they are marked immediately and never flash.

  Add to cart: the form submits normally (full page navigation to /cart), so the only job
  here is to show the button is working during that round trip. The label swaps to "Adding"
  and the button locks to prevent a double submit.
*/
(function () {
  var frames = document.querySelectorAll('[data-cover-frame]');
  Array.prototype.forEach.call(frames, function (frame) {
    var image = frame.querySelector('[data-cover-image]');
    if (!image) {
      frame.classList.add('is-loaded');
      return;
    }

    function markLoaded() {
      frame.classList.add('is-loaded');
    }

    if (image.complete && image.naturalWidth > 0) {
      markLoaded();
      return;
    }

    image.addEventListener('load', markLoaded, { once: true });
    // On decode failure still clear the shimmer, otherwise it would spin forever.
    image.addEventListener('error', markLoaded, { once: true });
  });

  var form = document.querySelector('[data-cart-form]');
  if (!form) return;

  var button = form.querySelector('[data-cart-submit]');
  var label = form.querySelector('[data-cart-label]');
  if (!button || !label) return;

  form.addEventListener('submit', function () {
    if (button.disabled) return;
    button.classList.add('is-loading');
    label.textContent = 'Adding';
    // Leave the button enabled for one frame so the browser still submits the form,
    // then lock it against a second click.
    window.setTimeout(function () {
      button.disabled = true;
    }, 0);
  });
})();

